export type GeoUiLang = 'ru' | 'hy' | 'en';

export interface GeoWorkspaceCopy {
  languageName: string;
  title: string;
  subtitle: string;
  deposit: string;
  live: string;
  newAnalysis: string;
  conversation: string;
  quickAnalysis: string;
  scope: string;
  reviewedCorpus: string;
  publishedGraph: string;
  notPublished: string;
  sources: string;
  activeSources: string;
  records: string;
  boreholes: string;
  coordinates: string;
  issues: string;
  manageSources: string;
  sourceHealth: string;
  pdfVerified: string;
  requiresReview: string;
  uploadSource: string;
  close: string;
  heroEyebrow: string;
  heroTitle: string;
  heroBody: string;
  askLabel: string;
  placeholder: string;
  send: string;
  analysing: string;
  shortcut: string;
  clear: string;
  question: string;
  answerReady: string;
  error: string;
  retry: string;
  copy: string;
  copied: string;
  evidenceAnswer: string;
  reports: string;
  books: string;
  findings: string;
  metrics: string;
  visualAnalysis: string;
  evidenceTables: string;
  calculations: string;
  conflicts: string;
  missingEvidence: string;
  coverage: string;
  expertCommentary: string;
  technicalDetails: string;
  globalMap: string;
  boreholeMap: string;
  showAll: string;
  showLess: string;
  sourceEvidence: string;
  reviewBoundary: string;
  dataOrigin: string;
  immutableEvidence: string;
  noSourcesTitle: string;
  noSourcesBody: string;
  sourcePanelTitle: string;
  sourcePanelBody: string;
  loadingSources: string;
  sourceLoadError: string;
  retryLoad: string;
  noSources: string;
  report: string;
  files: string;
  fileActive: string;
  fileInactive: string;
  size: string;
  sha: string;
  sheets: string;
  gaps: string;
  coordinateState: string;
  pdfEvidence: string;
  reviewedAt: string;
  removeReplace: string;
  removeQuestion: string;
  yes: string;
  no: string;
  dropTitle: string;
  dropHint: string;
  duplicate: string;
  uploadError: string;
  workbookExpected: string;
  promptGroups: Array<{ label: string; description: string; question: string }>;
}

export const GEO_COPY: Record<GeoUiLang, GeoWorkspaceCopy> = {
  ru: {
    languageName: 'Рус',
    title: 'Геологический интеллект',
    subtitle: 'Документы, данные и профессиональная геологическая экспертиза',
    deposit: 'Саригюх · Армения', live: 'Профессиональный AI-геолог готов',
    newAnalysis: 'Новый анализ', conversation: 'Текущий диалог', quickAnalysis: 'Быстрый анализ',
    scope: 'Область знаний', reviewedCorpus: 'Проверенные загрузки',
    publishedGraph: 'Опубликованный граф', notPublished: 'ещё не опубликован',
    sources: 'Источники', activeSources: 'активных книг', records: 'записей',
    boreholes: 'скважина', coordinates: 'координаты', issues: 'требуют внимания',
    manageSources: 'Управлять источниками', sourceHealth: 'Состояние корпуса',
    pdfVerified: 'PDF подтверждён', requiresReview: 'Нужна проверка', uploadSource: 'Добавить источник',
    close: 'Закрыть',
    heroEyebrow: 'Профессиональный геологический агент',
    heroTitle: 'Задайте вопрос — агент исследует данные и объяснит вывод',
    heroBody: 'GPT-5.6 Sol ищет по документам, проверяет структурированные значения и применяет знания геолога, минералога и химика. Факты из источников, расчёты и профессиональная интерпретация всегда разделены.',
    askLabel: 'Вопрос AI-геологу',
    placeholder: 'Спросите о составе, запасах, скважинах, горизонтах, качестве данных или сравните источники…',
    send: 'Отправить', analysing: 'Анализирую корпус…', shortcut: '⌘/Ctrl + Enter', clear: 'Очистить диалог',
    question: 'Вы', answerReady: 'Ответ готов', error: 'Не удалось выполнить анализ', retry: 'Повторить',
    copy: 'Копировать вывод', copied: 'Скопировано', evidenceAnswer: 'Ответ по доказательствам',
    reports: 'отчёта', books: 'книг', findings: 'Ключевые выводы', metrics: 'Показатели',
    visualAnalysis: 'Визуальный анализ', evidenceTables: 'Доказательства и таблицы',
    calculations: 'Расчёты', conflicts: 'Конфликты данных', missingEvidence: 'Пробелы в доказательствах',
    coverage: 'Покрытие и ограничения', expertCommentary: 'Экспертная интерпретация AI-геолога',
    technicalDetails: 'Техническая трассировка', globalMap: 'Глобальная карта', boreholeMap: 'Карта скважин',
    showAll: 'Показать все', showLess: 'Свернуть', sourceEvidence: 'Использованные источники',
    reviewBoundary: 'Агент разделяет факты из документов, расчёты и собственную профессиональную интерпретацию. Непроверенные значения не выдаются за достоверные.',
    dataOrigin: 'Источник каждого числа сохраняется', immutableEvidence: 'Исходные значения не изменяются',
    noSourcesTitle: 'Подключите документы — или задайте общий вопрос',
    noSourcesBody: 'Без активных источников агент может отвечать как специалист, но честно отметит, что ответ не подтверждён данными месторождения.',
    sourcePanelTitle: 'Источники и доказательства',
    sourcePanelBody: 'Управляйте активным корпусом. Загрузка не публикует данные в граф знаний.',
    loadingSources: 'Загрузка источников…', sourceLoadError: 'Не удалось загрузить список источников.',
    retryLoad: 'Повторить', noSources: 'Источников пока нет.', report: 'Отчёт', files: 'книг',
    fileActive: 'Активен', fileInactive: 'Отключён', size: 'Размер', sha: 'SHA256', sheets: 'Листов',
    gaps: 'Пропусков', coordinateState: 'Координаты', pdfEvidence: 'PDF / доказательства',
    reviewedAt: 'Проверено', removeReplace: 'Удалить и заменить', removeQuestion: 'Удалить источник?',
    yes: 'да', no: 'нет', dropTitle: 'Перетащите .xlsx-книги сюда или выберите файлы',
    dropHint: 'Можно загрузить несколько файлов · загрузка ≠ публикация', duplicate: 'дубликат',
    uploadError: 'ошибка', workbookExpected: 'Ожидается файл .xlsx.',
    promptGroups: [
      { label: 'Минералы и химия', description: 'Состав, свойства и пробы', question: 'Какой химический и минеральный состав проб отчёта 1989 года?' },
      { label: 'Запасы', description: 'Горизонты, марки и суммы', question: 'Покажи запасы по горизонтам за 1989 год и объясни ограничения.' },
      { label: 'Скважины', description: 'Расположение и качество координат', question: 'Что известно о скважинах и каким координатам требуется проверка?' },
      { label: 'Надёжность данных', description: 'Конфликты, пропуски и риски', question: 'Каким данным пока нельзя доверять и почему?' },
    ],
  },
  hy: {
    languageName: 'Հայ',
    title: 'Երկրաբանական ինտելեկտ', subtitle: 'Փաստաթղթեր, տվյալներ և մասնագիտական երկրաբանական փորձաքննություն',
    deposit: 'Սարիգյուղ · Հայաստան', live: 'Մասնագիտական AI-երկրաբանը պատրաստ է',
    newAnalysis: 'Նոր վերլուծություն', conversation: 'Ընթացիկ երկխոսություն', quickAnalysis: 'Արագ վերլուծություն',
    scope: 'Գիտելիքի տիրույթ', reviewedCorpus: 'Ստուգված բեռնումներ', publishedGraph: 'Հրապարակված գրաֆ',
    notPublished: 'դեռ հրապարակված չէ', sources: 'Աղբյուրներ', activeSources: 'ակտիվ գիրք', records: 'գրառում',
    boreholes: 'հորատանցք', coordinates: 'կոորդինատ', issues: 'ուշադրություն է պահանջում',
    manageSources: 'Կառավարել աղբյուրները', sourceHealth: 'Կորպուսի վիճակ', pdfVerified: 'PDF-ը հաստատված է',
    requiresReview: 'Պետք է ստուգել', uploadSource: 'Ավելացնել աղբյուր', close: 'Փակել',
    heroEyebrow: 'Մասնագիտական երկրաբանական գործակալ', heroTitle: 'Հարց տվեք՝ գործակալը կուսումնասիրի տվյալները և կբացատրի եզրակացությունը',
    heroBody: 'GPT-5.6 Sol-ը որոնում է փաստաթղթերում, ստուգում կառուցվածքային արժեքները և կիրառում երկրաբանի, հանքաբանի ու քիմիկոսի գիտելիքները։ Աղբյուրների փաստերը, հաշվարկներն ու մասնագիտական մեկնաբանությունը միշտ տարանջատված են։',
    askLabel: 'Հարց AI-երկրաբանին',
    placeholder: 'Հարցրեք կազմի, պաշարների, հորատանցքերի, հորիզոնների, տվյալների որակի մասին կամ համեմատեք աղբյուրները…',
    send: 'Ուղարկել', analysing: 'Վերլուծում եմ կորպուսը…', shortcut: '⌘/Ctrl + Enter', clear: 'Մաքրել երկխոսությունը',
    question: 'Դուք', answerReady: 'Պատասխանը պատրաստ է', error: 'Վերլուծությունը չհաջողվեց', retry: 'Կրկնել',
    copy: 'Պատճենել եզրակացությունը', copied: 'Պատճենված է', evidenceAnswer: 'Ապացույցների վրա հիմնված պատասխան',
    reports: 'հաշվետվություն', books: 'գիրք', findings: 'Հիմնական եզրակացություններ', metrics: 'Ցուցանիշներ',
    visualAnalysis: 'Տեսողական վերլուծություն', evidenceTables: 'Ապացույցներ և աղյուսակներ', calculations: 'Հաշվարկներ',
    conflicts: 'Տվյալների հակասություններ', missingEvidence: 'Ապացույցների բացեր', coverage: 'Ծածկույթ և սահմանափակումներ',
    expertCommentary: 'AI-երկրաբանի մասնագիտական մեկնաբանություն', technicalDetails: 'Տեխնիկական հետագիծ',
    globalMap: 'Գլոբալ քարտեզ', boreholeMap: 'Հորատանցքերի քարտեզ', showAll: 'Ցույց տալ բոլորը',
    showLess: 'Կրճատել', sourceEvidence: 'Օգտագործված աղբյուրներ',
    reviewBoundary: 'Գործակալը տարանջատում է փաստաթղթերի փաստերը, հաշվարկները և սեփական մասնագիտական մեկնաբանությունը։ Չստուգված արժեքները չեն ներկայացվում որպես հավաստի։',
    dataOrigin: 'Յուրաքանչյուր թվի աղբյուրը պահպանվում է', immutableEvidence: 'Սկզբնական արժեքները չեն փոխվում',
    noSourcesTitle: 'Միացրեք փաստաթղթերը կամ տվեք ընդհանուր հարց', noSourcesBody: 'Առանց ակտիվ աղբյուրների գործակալը կարող է պատասխանել որպես մասնագետ, բայց կնշի, որ պատասխանը հաստատված չէ հանքավայրի տվյալներով։',
    sourcePanelTitle: 'Աղբյուրներ և ապացույցներ', sourcePanelBody: 'Կառավարեք ակտիվ կորպուսը։ Վերբեռնումը տվյալները չի հրապարակում գրաֆում։',
    loadingSources: 'Աղբյուրները բեռնվում են…', sourceLoadError: 'Չհաջողվեց բեռնել աղբյուրների ցանկը։', retryLoad: 'Կրկնել',
    noSources: 'Աղբյուրներ դեռ չկան։', report: 'Հաշվետվություն', files: 'գիրք', fileActive: 'Ակտիվ', fileInactive: 'Անջատված',
    size: 'Չափ', sha: 'SHA256', sheets: 'Թերթեր', gaps: 'Բացեր', coordinateState: 'Կոորդինատներ',
    pdfEvidence: 'PDF / ապացույցներ', reviewedAt: 'Ստուգված է', removeReplace: 'Ջնջել և փոխարինել',
    removeQuestion: 'Ջնջե՞լ աղբյուրը', yes: 'այո', no: 'ոչ',
    dropTitle: 'Քաշեք .xlsx գրքերը այստեղ կամ ընտրեք ֆայլերը', dropHint: 'Կարելի է մի քանի ֆայլ · վերբեռնում ≠ հրապարակում',
    duplicate: 'կրկնօրինակ', uploadError: 'սխալ', workbookExpected: 'Սպասվում է .xlsx ֆայլ։',
    promptGroups: [
      { label: 'Միներալներ և քիմիա', description: 'Կազմ, հատկություններ և նմուշներ', question: 'Ի՞նչ քիմիական և միներալային կազմ ունեն 1989 թ. հաշվետվության նմուշները։' },
      { label: 'Հորատանցքեր', description: 'Դիրք և կոորդինատների որակ', question: 'Ի՞նչ է հայտնի հորատանցքերի մասին և ո՞ր կոորդինատներն են ստուգում պահանջում։' },
      { label: 'Տվյալների վստահելիություն', description: 'Հակասություններ, բացեր և ռիսկեր', question: 'Ո՞ր տվյալներին դեռ չի կարելի վստահել և ինչո՞ւ։' },
    ],
  },
  en: {
    languageName: 'Eng',
    title: 'Geological intelligence', subtitle: 'Documents, data, and professional geological expertise',
    deposit: 'Sarigyugh · Armenia', live: 'Professional AI geologist ready', newAnalysis: 'New analysis',
    conversation: 'Current conversation', quickAnalysis: 'Quick analysis', scope: 'Knowledge scope',
    reviewedCorpus: 'Reviewed uploads', publishedGraph: 'Published graph', notPublished: 'not published yet',
    sources: 'Sources', activeSources: 'active workbooks', records: 'records', boreholes: 'boreholes',
    coordinates: 'coordinates', issues: 'need attention', manageSources: 'Manage sources', sourceHealth: 'Corpus health',
    pdfVerified: 'PDF verified', requiresReview: 'Review required', uploadSource: 'Add source', close: 'Close',
    heroEyebrow: 'Professional geological agent', heroTitle: 'Ask a question — the agent investigates the data and explains the conclusion',
    heroBody: 'GPT-5.6 Sol searches the documents, checks structured values, and applies professional geology, mineralogy, and chemistry knowledge. Source facts, calculations, and professional interpretation remain visibly separate.',
    askLabel: 'Question for the AI geologist',
    placeholder: 'Ask about composition, reserves, boreholes, horizons, data quality, or compare sources…',
    send: 'Send', analysing: 'Analysing the corpus…', shortcut: '⌘/Ctrl + Enter', clear: 'Clear conversation',
    question: 'You', answerReady: 'Answer ready', error: 'The analysis could not be completed', retry: 'Retry',
    copy: 'Copy conclusion', copied: 'Copied', evidenceAnswer: 'Evidence-based answer', reports: 'reports', books: 'workbooks',
    findings: 'Key findings', metrics: 'Metrics', visualAnalysis: 'Visual analysis',
    evidenceTables: 'Evidence and tables', calculations: 'Calculations', conflicts: 'Data conflicts',
    missingEvidence: 'Evidence gaps', coverage: 'Coverage and limitations', expertCommentary: 'AI geologist expert interpretation',
    technicalDetails: 'Technical trace', globalMap: 'Global map', boreholeMap: 'Borehole map',
    showAll: 'Show all', showLess: 'Show less', sourceEvidence: 'Sources used',
    reviewBoundary: 'The agent separates document facts, calculations, and its own professional interpretation. Unreviewed values are never presented as confirmed.',
    dataOrigin: 'Every number retains its source', immutableEvidence: 'Original values are never changed',
    noSourcesTitle: 'Connect documents — or ask a general question', noSourcesBody: 'Without active sources the agent can still answer as a specialist, but will state that the answer is not confirmed by deposit data.',
    sourcePanelTitle: 'Sources and evidence', sourcePanelBody: 'Manage the active corpus. Uploading does not publish data to the knowledge graph.',
    loadingSources: 'Loading sources…', sourceLoadError: 'The source list could not be loaded.', retryLoad: 'Retry',
    noSources: 'No sources yet.', report: 'Report', files: 'workbooks', fileActive: 'Active', fileInactive: 'Inactive',
    size: 'Size', sha: 'SHA256', sheets: 'Sheets', gaps: 'Gaps', coordinateState: 'Coordinates',
    pdfEvidence: 'PDF / evidence', reviewedAt: 'Reviewed', removeReplace: 'Remove and replace',
    removeQuestion: 'Remove this source?', yes: 'yes', no: 'no',
    dropTitle: 'Drop .xlsx workbooks here or choose files', dropHint: 'Multiple files allowed · upload ≠ publication',
    duplicate: 'duplicate', uploadError: 'error', workbookExpected: 'An .xlsx file is required.',
    promptGroups: [
      { label: 'Minerals & chemistry', description: 'Composition, properties, and samples', question: 'What is the chemical and mineral composition of the 1989 report samples?' },
      { label: 'Reserves', description: 'Horizons, grades, and totals', question: 'Show reserves by horizon for 1989 and explain the limitations.' },
      { label: 'Boreholes', description: 'Locations and coordinate quality', question: 'What is known about the boreholes and which coordinates require review?' },
      { label: 'Data reliability', description: 'Conflicts, gaps, and risk', question: 'Which data cannot be trusted yet, and why?' },
    ],
  },
};

export function translateSourceStatus(status: string, lang: GeoUiLang): string {
  if (lang === 'ru') return status;
  const translated: Record<Exclude<GeoUiLang, 'ru'>, Record<string, string>> = {
    en: {
      'Книга проверена': 'Workbook reviewed',
      'Доступно для предварительного анализа': 'Available for analysis',
      'Координаты готовы для карты': 'Coordinates ready for mapping',
      'Требуется проверка': 'Review required',
      'Оригинальный PDF не подключён': 'Original PDF not connected',
      'Оригинальный PDF подключён и проверен': 'Original PDF connected and verified',
      'Система координат не подтверждена': 'Coordinate system not confirmed',
      'Источник не опубликован': 'Source not published',
      'Местная система координат без опорных точек': 'Local coordinate system without control points',
      'Координаты не найдены': 'Coordinates not found',
    },
    hy: {
      'Книга проверена': 'Աշխատանքային գիրքը ստուգված է',
      'Доступно для предварительного анализа': 'Հասանելի է վերլուծության համար',
      'Координаты готовы для карты': 'Կոորդինատները պատրաստ են քարտեզագրման',
      'Требуется проверка': 'Պահանջվում է ստուգում',
      'Оригинальный PDF не подключён': 'Բնօրինակ PDF-ը միացված չէ',
      'Оригинальный PDF подключён и проверен': 'Բնօրինակ PDF-ը միացված և ստուգված է',
      'Система координат не подтверждена': 'Կոորդինատային համակարգը հաստատված չէ',
      'Источник не опубликован': 'Աղբյուրը հրապարակված չէ',
      'Местная система координат без опорных точек': 'Տեղային կոորդինատային համակարգ՝ առանց հենակետերի',
      'Координаты не найдены': 'Կոորդինատներ չեն գտնվել',
    },
  };
  return translated[lang][status] ?? status;
}
